export function addTargetBlankToExternalLinks() {
  console.log('Setting external links to open in new tab');

  document.querySelectorAll('a').forEach((link) => {
    if (link.hostname !== window.location.hostname) {
      link.target = '_blank';
    }
  });
}
